const DURATION = 500;
import reveil from '@/utils/reveil';

class Statistic {

	constructor() {
		this.init();
		this.steps = [];
	}

	init() {
		this.loop = this.loop.bind(this);
		this.loop();
		$('.wp-block-kbk-statistic').each((i, el) => {
			reveil.add(el, () => this.startCounter(el));
		});
	}

	startCounter(counter) {
		const numbers = $(counter).find('.js-statistic-number');
		$(numbers).each((i, el) => this.countNumber(el));
	}

	countNumber(el) {
		const targetNumber = $(el).data('number');
		const endTime = Date.now() + DURATION;

		const update = () => {
			const now = Date.now();
			const elapsed  = Math.min(1 - (endTime - now) / DURATION, 1);
			const currentValue = Math.round(elapsed * targetNumber);
			const localeNumber = currentValue.toLocaleString('nl-NL');
			$(el).text(localeNumber);

			if (currentValue >= targetNumber) {
				this.steps.splice(this.steps.indexOf(update), 1);
			}
		};

		this.steps.push(update);
	}

	loop() {
		if (this.steps?.length > 0) {
			this.steps.forEach(step => step());
		}
		window.requestAnimationFrame(this.loop);
	}

}

const statistic = new Statistic();